<script setup>
import NewsCard from '@sections/news/news-card.vue'
import { useNewsStore } from '@stores/news'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

import Button from '@components/global/button.vue'

const news = useNewsStore()
</script>

<template>
	<section class="lg:gap-15 container flex flex-col gap-10 text-default">
		<div class="relative flex flex-col items-center lg:mt-16 lg:block lg:columns-2 lg:gap-x-[10%]">
			<div class="absolute bottom-0 left-[50%] top-0 hidden translate-x-[-50%] lg:block">
				<div class="h-[100%] w-[1px] border-l border-dashed border-border-default">
					<div class="sticky top-[15rem] ml-[-5px] h-2 w-2 rotate-45 bg-purple-base" />
				</div>
			</div>

			<div class="relative mb-8 max-w-[100%] p-4 lg:mb-32">
				<div class="overflow-hidden">
					<swiper slides-per-view="auto">
						<swiper-slide>
							<Button @click="news.setFilter(null)" :without-edge="true">
								<i v-if="news.filter === null" class="icon-button-edge text-[6px]" />
								<span class="hover:opacity-70">All News</span>
							</Button>
						</swiper-slide>
						<swiper-slide v-for="category in news.categories">
							<Button @click="news.setFilter(category.slug)" :without-edge="true">
								<i v-if="news.filter === category.slug" class="icon-button-edge text-[6px]" />
								<span class="hover:opacity-70">{{ category.name }}</span>
							</Button>
						</swiper-slide>
					</swiper>
				</div>
				<div class="categories-border" />
			</div>

			<div v-for="article of news.filtered" :key="article.title" class="mb-8 lg:mb-32">
				<router-link :to="{ name: 'article', params: { slug: article.slug } }" :without-edge="true">
					<NewsCard :article="article" />
				</router-link>
			</div>
		</div>
	</section>
</template>

<style scoped>
.swiper-slide {
	width: fit-content;
}

.categories-border {
	@apply absolute right-[-2rem] top-[-2rem] hidden h-20 w-40 rounded-tr-[16px] border-r border-t border-r-default border-t-default lg:block;
}

.categories-border::after {
	position: absolute;
	top: 16px;
	right: 16px;
	content: '';
	display: block;
	width: 3px;
	height: 3px;
	background: #9e76b2;
}
</style>
